import ru from './policy.ru.json';
import az from './policy.az.json';
import en from './policy.en.json';
import { getUiLocale } from '../i18n/uiText';

export const policies = { ru, az, en };
export const policyLanguages = [['ru', 'Русский'], ['az', 'Azərbaycanca'], ['en', 'English']];
export const policyPdfUrl = `${(process.env.PUBLIC_URL || '/audit-pro').replace(/\/$/, '')}/legal/personal-data-policy-ru.pdf`;
const key = 'audit-pro:legal-language';
export function initialPolicyLanguage(explicit) {
  if (Object.hasOwn(policies, explicit)) return explicit;
  if (explicit) return 'ru';
  try {
    const saved = localStorage.getItem(key);
    return Object.hasOwn(policies, saved) ? saved : getUiLocale();
  } catch { return 'ru'; }
}
export function savePolicyLanguage(language) {
  if (!Object.hasOwn(policies, language)) return;
  try { localStorage.setItem(key, language); } catch { /* Reading is available without browser storage. */ }
}
export const policyCopy = {
  ru: {
    link: 'Политика обработки персональных данных', heading: 'Правовая информация', language: 'Язык документа',
    original: 'Оригинал PDF · Русский', close: 'Закрыть', back: 'Вернуться ко входу', contents: 'Содержание', metadata: 'Реквизиты документа',
    source: 'Полный текст предоставленного документа: 8 разделов и 2 приложения. Оригинал PDF доступен для скачивания.',
    translation: 'Справочный перевод с русского языка. Это не отдельная утверждённая редакция документа. Оригинал доступен в PDF на русском языке.',
    appendix: 'Далее приведены образцы согласий из приложений к политике. Значения «Да» воспроизведены из оригинала и не означают вашего согласия. Просмотр этой страницы не подписывает документы и не отправляет указанные в образцах данные.',
    table: 'Таблица из документа',
  },
  az: {
    link: 'Fərdi məlumatların işlənilməsi siyasəti', heading: 'Hüquqi məlumat', language: 'Sənədin dili',
    original: 'Orijinal PDF · Rus dili', close: 'Bağla', back: 'Girişə qayıt', contents: 'Mündəricat', metadata: 'Sənədin rekvizitləri',
    source: 'Təqdim edilmiş sənədin tam mətni: 8 bölmə və 2 əlavə. Orijinal PDF-i yükləmək mümkündür.',
    translation: 'Rus dilindən məlumat üçün tərcümədir. Sənədin ayrıca təsdiq edilmiş redaksiyası deyil. Orijinal rus dilində PDF formatında mövcuddur.',
    appendix: 'Aşağıda siyasətin əlavələrindəki razılıq nümunələri verilir. «Bəli» dəyərləri orijinaldan köçürülüb və sizin razılığınızı bildirmir. Bu səhifəyə baxmaq sənədləri imzalamır və nümunələrdə göstərilən məlumatları göndərmir.',
    table: 'Sənəddəki cədvəl',
  },
  en: {
    link: 'Personal data processing policy', heading: 'Legal information', language: 'Document language',
    original: 'Original PDF · Russian', close: 'Close', back: 'Back to sign in', contents: 'Contents', metadata: 'Document details',
    source: 'Full text of the supplied document: 8 sections and 2 appendices. The original PDF is available to download.',
    translation: 'Reference translation from Russian. This is not a separately approved version of the document. The original is available as a Russian-language PDF.',
    appendix: 'The following are sample consent forms from the policy appendices. The “Yes” entries reproduce the original and do not indicate your consent. Viewing this page does not sign any document or submit the data described in the forms.',
    table: 'Table from the document',
  },
};
